module.exports = __webpack_public_path__ + "media/images/logos/mcdonalds-5283e43013f98f8a8c8c174570af0cb6.png";